module.exports = __webpack_public_path__ + "0b468e395103cc0594b0daed90fbed0d.svg";